import { EntityBuilder } from '@decahedron/entity';
import ApiService from '@/services/api';
import User from '@/entities/User';

let instance: AuthService = null;

export default class AuthService {
    protected currentUserEntity: User = null;

    apiService: ApiService = null;

    userFetched = false;

    decodedTokenObject: any = null;

    constructor() {
        if (!instance) {
            this.reset();
        }

        return instance;
    }

    reset() {
        this.apiService = new ApiService();
        this.decodedTokenObject = null;
        instance = this;
    }

    get isLoggedIn(): boolean {
        return !!this.currentUser;
    }

    get currentUser(): User {
        if (!this.userFetched) {
            this.getCurrentUser()
                .then((user: User = null) => {
                    this.currentUserEntity = user;
                })
                .catch(() => {
                    this.currentUserEntity = null;
                });
        }

        return this.currentUserEntity;
    }

    set currentUser(user: User) {
        if (this.currentUserEntity.id === user.id) {
            this.currentUserEntity = user;
        }
    }

    login(username: string, password: string) {
        const formData = new FormData();
        formData.append('grant_type', 'password');
        formData.append('client_id', process.env.VUE_APP_OAUTH_CLIENT_ID || '2');
        formData.append('client_secret', process.env.VUE_APP_OAUTH_CLIENT_SECRET || '1oOpydCnFDVruNQiDwh22TXTDbIdM6dyfTUKjRR6');
        formData.append('scope', '');
        formData.append('username', username);
        formData.append('password', password);

        return this.apiService.post('oauth/token', formData)
            .then((response) => {
                this.apiService.token = response.access_token;
            }).finally(() => {
                this.userFetched = false;
            });
    }

    logout() {
        this.apiService.token = null;
        this.reset();
    }

    async getCurrentUser() {
        this.userFetched = true;
        return this.apiService.get('users/current')
            .then((response) => {
                if (response && response.data) {
                    return EntityBuilder.buildOne(User, response.data);
                }
                return null;
            });
    }
}
